import * as messageService from "../../services/message.service";
import * as australianResidencyStatusService from '../../services/australianResidencyStatus.service';


const state = {
    australianResidencyStatusAll:[],
    australianResidencyStatusAllActive:[],
};

const getters = {
    getAustralianResidencyStatusAll:state => (state.australianResidencyStatusAll),
    getAustralianResidencyStatusAllActive:state => (state.australianResidencyStatusAllActive),
};

const actions = {
    async fetchAustralianResidencyStatusAll({ commit } ){
        try {
            const response = await australianResidencyStatusService.all();
            commit('setAustralianResidencyStatusAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchAustralianResidencyStatusAllActive({ commit } ){
        try {
            const response = await australianResidencyStatusService.allActive();
            commit('setAustralianResidencyStatusAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setAustralianResidencyStatusAll:(state, res) => (
        state.australianResidencyStatusAll =  res
    ),
    setAustralianResidencyStatusAllActive:(state, res) => (
        state.australianResidencyStatusAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}